import { css } from 'styled-components';
import { Breakpoints, responsiveValue } from './media';

export const colors = {
  transparent: 'rgba(255, 255, 255, 0)',
  white: '#ffffff',
  black: '#000000',
  primary: '#000037',
  secondaryBlue: '#F8FAFA',
  pink: '#fdf2f0',
  secondaryPink: '#FDF2F0',
  darkPink: '#F3E7E5',
  border: '#80809B',
  disabled: '#DDDDE0',
  gray: '#A8ABAF',
  darkMiddleGray: '#c4c4c4',
  middleGray: '#E1DDE2',
  lightGray: '#E9E9E9',
  error: '#C57283',
  pinkWash: '#f9f4f4',
};

export const fonts = {
  primary: 'BasisGrotesque-Regular',
  winnow: 'BasisGrotesqueProWinnowBeta12-Regular',
  secondary: 'SangBleuVersailles-Regular',
  icon: 'icomoon',
};

export const border = {
  regular: `1px solid ${colors.border}`,
  button: css`
    border: 1px solid ${colors.border};
  `,
  buttonDisabled: css`
    border: 1px solid ${colors.disabled};
  `,
};

export const shadow = {
  primary: css`
    box-shadow: 10px 10px 0 rgba(0, 0, 55, 0.1);
  `,
};

export const gradient = {
  primary: `linear-gradient(270deg, ${colors.secondaryBlue}, ${colors.white})`,
  secondary: `linear-gradient(270deg, ${colors.darkPink}, ${colors.transparent})`,
};

export const sizes = {
  header: 80,
  contentPadding: responsiveValue(24, { tablet: 56 }),
  contentVerticalMargin: responsiveValue(32, { tablet: 56 }),
};

export const activeBreakpoint = responsiveValue(Breakpoints.MOBILE, {
  [Breakpoints.DESKTOP_FULL]: Breakpoints.DESKTOP_FULL,
  [Breakpoints.DESKTOP_WIDE]: Breakpoints.DESKTOP_WIDE,
  [Breakpoints.DESKTOP]: Breakpoints.DESKTOP,
  [Breakpoints.TABLET]: Breakpoints.TABLET,
  [Breakpoints.TABLET_PORTRAIT]: Breakpoints.TABLET_PORTRAIT,
  [Breakpoints.MOBILE_BIG]: Breakpoints.MOBILE_BIG,
});

export const zIndexes = {
  content: 0,
  overContent: 1,
  header: 5,
  overlay: 10,
  overlayHeader: 11,
  authOverlay: 15,
  snackbar: 20,
  filterModal: 25,
  cookiesBar: 30,
};

export default {
  colors,
  fonts,
  border,
  shadow,
  sizes,
  zIndexes,
  activeBreakpoint,
  gradient,
};
